import { AlertTriangle, RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export function ErrorState({ title, description, onRetry }: ErrorStateProps) {
  const { t } = useTranslation('common');
  return (
    <Card>
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        <div className="h-12 w-12 rounded-lg bg-destructive-light flex items-center justify-center mb-4">
          <AlertTriangle className="h-6 w-6 text-destructive-ink" />
        </div>
        <h3 className="text-lg font-semibold mb-1.5">{title ?? t('errorState.title')}</h3>
        <p className="text-sm text-muted-foreground max-w-sm mb-5">
          {description ?? t('errorState.description')}
        </p>
        {onRetry && (
          <Button variant="outline" onClick={onRetry} className="gap-2">
            <RotateCcw className="h-4 w-4" />
            {t('errorState.retry')}
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
